import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as qs from 'query-string';
import { withRouter } from 'react-router-dom';
import { FadeLoader } from 'react-spinners';
import _ from 'lodash';
import { fetchProveedorEquposAdicionales,
  fetchPedidos,
  fetchClientes,
  fetchFichasVenta,
  fetchFichaVentaCorreos,//Req 92528 ebarboza 28 08 2021
  fetchClientesPedidos,
  fetchFichaVenta,
  fetchAutorizaciones,
  fetchProformas,
  fetchHistorialFDV,
  loadFichasVenta,
  clearProformas,
  fetchEstados,
  fetchTipoAutorizacion,
  fetchResponsables,
  fetchAutorizacionesExcepcionales,
  fetchFacturacion,
  fetchEditarFacturacion,
  fetchReporteFichaVenta,
  fetchReporteConsultaFichaVenta,
  fetchEquiposCortesia,
  fetchGestionCosto,
  fetchEquiposAdicionales,
  fetchEquiposLogisticaDetalle,
  fetchAutorizacionesUsuarios,
  fetchSolicitudesFacturacion,
  saveAutorizacionesExcepcionales,
  fetchSeguimientoAutorizaciones,
  validarUsuarioAutorizador,
  fetchPermisos,
  fetchTipoActividad
} from '../../actions';
import PageHeader from '../../components/PageHeader';
import NuevaFichaVenta from '../modals/NuevaFichaVenta';
import Alert from '../../components/Alert';
import BuscarFicha from './BuscarFicha';
import Detalle from './Detalle';
import Tabs from './Tabs';
import PedidoDetalle from './DetallePedido/PedidoDetalle';
import renderTabcontainer from './TabViews';
import showModal from './showModal';
import toggleDiv from '../../utils/toggleDiv';
import autorizarActividad from '../../utils/autorizarActividad';
import { loadPermissions,
  validatePermissions,
  isPermissionValid,
  hasPermissionMessage,
  validatePermissionsMassive,
  isValidProcessMassive,
  getPermisosPedidos } from '../../utils/permissions';
import getPedidosFechas from '../../utils/getPedidosFechas';
import getPedidosPedidos from '../../utils/getPedidosPedidos';
import saveAs from '../../utils/downloadFile';

const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_CLIENTE='2';
const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_MULTIPLE='1';
const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_LISTADO_TOTAL='0';
const SIN_PAGINACION='N';
const CON_PAGINACION='N';
const PAGINA='1';
const NUMERO_PAGINAS='10';
const VACIO='';
const COD_ID_PROCCESS='0';
const VACIO_PATH = '123';
const CONSULTA_CLIENTES='cadena'
const CONSULTA_TIPO='A'
const ESTADO_PEDIDO_ASIGNADO = 'ASIGNADO';

class DetalleFichaVenta extends Component {
  constructor(props) {
    super(props);

    const params = qs.parse(this.props.location.search);
    const modalOpen = params.cliente ? 'nueva-fdv' : '';

    this.state = {
      searchInput: '',
      tabSeleccionado: 0,
      typeSearch: 'nfdv',
      alertErrorOpen: false,
      alertErrorOpenModFacturacion: false,
      alertErrorMessage: '',
      alertSuccessOpen: false,
      alertSuccessMessage: '',
      // proformas
      proformaSeleccionada: '',
      // modal
      modalOpen,
      facturacionListado: [],
      facturacionGrupo: [],
      cantidadListadoFacturacion: '0',
      listCodFacturacion: [],
      listCodPropietario: [],
      listCodUsuario: [],
      listClientes: [],
      clientInput: '',
      searchOption: 'cadena',
      varCheckDefault: [],
      arrayLibresPedidos: [],
      arrayLibresPedidosPropietario: [],
      arrayLibresPedidosUsuario: [],
      pedClieCount: 0,
      pedPropCount: 0,
      pedFactCount: 0,
      muestraLoad: 'none',
      pedidoAcordeon: '',
      idsProformas: [],
      activeFilterPedido: 0,
      pedidosXfichaVenta: [],
      idFichaVenta: '',
      numProformaEquiposAdicionales: '',
      pedidosEquiposAdicionales: [],
      optionSearch: '',
      valueSerach: '',
      arrayAsignarBonos:[],
      equiposLogisticaPedidos: [],
      pedidosConCheck: [],
      numProfVehSeleccionado: '',
      proveedorEquipoLogistica: {codProv:'',nomPerso:''},
      proformaSeleccionadaTabEquipoLogistica : {},
      tipoLlamadaEquiposAdicionales:'0',
      proveedorEquposAdicionalesModalOpen:'true',
      pedidosClienteFacturacion:[],
      listUsuarioAprobadores:[],
      autorizaciones:[],
      solicitudfacturacion:[],
      facturacionListadoModal:[],
      autorizadoSeleccionado:[],
      equiposCortesia:[],
      seguimientoAutorizaciones:[],
      tipoAdicional:[],
      loadInitial:'block',
      numFichaVtaVeh:'',
      isFinishedAsignacionDefinitiva:false,
      isFinishedPermissionValidation:false,
      /*Inicio Req 92528 ebarboza 30 08 2021 */
      listaCorreos:[]
      /*Inicio Req 92528 ebarboza 30 08 2021 */
  };

    this.loadPage = this.loadPage.bind(this);
  }

  componentDidMount() {
    this.loadPage(0);
    console.log('cordenadaX',cordenadaX + ' ' + cordenadaY) ;
    let cordenadaX = 800;
    let cordenadaY = 800;
    window.scrollTo(3000, 3000);
  }

  handlePermissions = (e, numero) => {
    e.preventDefault();
    e.persist();
    if (!this.state.isFinishedPermissionValidation) {
      this.props
        .fetchPermisos(this.state.numFichaVtaVeh)
        .then(result => {
          loadPermissions(result.payload.data);
          const permission = validatePermissions(e, numero);
          if (hasPermissionMessage()) {
            this.showErrorMessage(permission.message);
          }
          this.setState({ isFinishedPermissionValidation: true });
          e.target.click();
        });
      return false;
    } else {
      this.setState({ isFinishedPermissionValidation: false });
      return isPermissionValid();
    }
  };

  handlePermissionsMassive = (e, list) => {
    e.preventDefault();
    e.persist();
    if (!this.state.isFinishedPermissionValidation) {
      this.props
        .fetchPermisos(this.state.numFichaVtaVeh)
        .then(result => {
          loadPermissions(result.payload.data);
          const messages = validatePermissionsMassive(e, list);
          const isValidProcess = isValidProcessMassive();
          if (!isValidProcess) {
            this.showErrorMessage(messages);
          }
          this.setState({ isFinishedPermissionValidation: true });
          e.target.click();
      });
      return false;
    } else {
      this.setState({ isFinishedPermissionValidation: false });
      return isValidProcessMassive();
    }
  }

  showErrorMessage = (msg) => {
    this.setState({ alertErrorMessage: msg });
    this.showAlert("alertErrorOpen");
  }

  doneAsignacionDefinitiva = (status) => {
    this.setState({isFinishedAsignacionDefinitiva:status});
  }

  pedidosXfichaVentaChange = (pedidosXfichaVenta) => {
    console.log('pedidosXfichaVenta',pedidosXfichaVenta);
    this.setState({pedidosXfichaVenta:pedidosXfichaVenta})
  }

  agregarPedidoFacturacion = (numPedido)=>{
  console.log("agregarPedidoFacturacion",numPedido)
  this.setState({ pedidosConCheck: [...this.state.pedidosConCheck,numPedido] });
  this.traerFacturacion(this.state.idFichaVenta);
  }

  traerFacturacion = (idFichaVenta) =>{

    this.props.fetchFacturacion(idFichaVenta, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_CLIENTE, SIN_PAGINACION, PAGINA, NUMERO_PAGINAS)
    .then((result) => {
      if (result.payload.data.estadoTrama === '1') {
        const ped = result.payload.data.listado
        .filter(element => element.numPedidoVeh.split(' ').filter(z => this.state.pedidosConCheck.filter(y => y === z).length !== 0).length !== 0);
        this.setState({
          pedidosClienteFacturacion: ped.map((row) => {
            const numPedidos = row.numPedidoVeh.split(' ').filter(z => this.state.pedidosConCheck.filter(y => y === z).length !== 0);
            return {
              'numPedidoVeh': numPedidos,
              'codClie': row.codClie,
              'desClie': row.desClie,
              'rucClie': row.rucClie,
              'dniClie': row.dniClie,
              'desFormPago': row.desFormPago,
              'desPropietarioVeh': row.desPropietarioVeh,
              'desTipoDoc': row.desTipoDoc,
              'desUsuarioVeh': row.desUsuarioVeh,
              'entidadFinancieraProf': row.entidadFinancieraProf,
              'nomUsuarioSolFact': row.nomUsuarioSolFact,
              'tipoSolFact': row.tipoSolFact,
              'codProv': row.codProv,
              'codCIA': row.codCIA,
              'numProfVeh':row.numProfVeh,
              'estadoTransitoFact':row.estadoTransitoFact
            };
          })
        });

      }
    }).catch(error => console.log(error));
  }

  fnSolicitudFacturacion = (id) =>  {

    this.props.fetchSolicitudesFacturacion(id,VACIO_PATH,VACIO)
    .then((result) => {
      console.log(result.payload.data);
      this.setState({ solicitudfacturacion: result.payload.data });
    }).catch((error) => {console.log(error)});
  }

  fnListadoPedidosFacturacion = (id) => {


    const promises = [];
    this.props.fetchPedidos(id);
    this.setState({ idFichaVenta: id });
    this.props.fetchFichaVenta(id);

    promises.push(this.props.fetchFacturacion(id, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_MULTIPLE, CON_PAGINACION, PAGINA, NUMERO_PAGINAS));
    promises.push(this.props.fetchFacturacion(id, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_LISTADO_TOTAL, CON_PAGINACION, VACIO, VACIO));
    promises.push(this.props.fetchClientes(CONSULTA_CLIENTES, CONSULTA_TIPO));
    promises.push(this.props.fetchFacturacion(id, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_CLIENTE, SIN_PAGINACION, PAGINA, NUMERO_PAGINAS))

    this.traerFacturacion(id);
    Promise.all(promises)
    .then((results) => {
      this.setState({
        facturacionGrupo: results[0].payload.data.listado,
        facturacionListado: results[1].payload.data.listado,
        cantidadListadoFacturacion: results[0].payload.data.cantidad,
        listClientes: results[2].payload.data,
        facturacionListadoModal: results[3].payload.data.listado,
      });

      this.state.facturacionListado.forEach((date) => {
         const { listCodFacturacion, listCodPropietario, listCodUsuario } = this.state;
         let { pedClieCount, pedPropCount, pedFactCount } = this.state;
         listCodFacturacion.push({ id: date.codClie, descripcion: date.desClie });
         listCodPropietario.push({ id: date.codPropietarioVeh, descripcion: date.desPropietarioVeh });
         listCodUsuario.push({ id: date.codUsuarioVeh, descripcion: date.desUsuarioVeh });

         this.setState({
           listCodFacturacion: this.deleteDuplicate(listCodFacturacion, 'id'),
           listCodPropietario: this.deleteDuplicate(listCodPropietario, 'id'),
           listCodUsuario: this.deleteDuplicate(listCodUsuario, 'id'),
           pedClieCount: date.numPedidoVeh !== null ? pedClieCount++ : null,
           pedPropCount: date.numPedidoVeh !== null ? pedPropCount++ : null,
           pedFactCount: date.numPedidoVeh !== null ? pedFactCount++ : null,
           muestraLoad: 'none',
         });
       });


       this.setState({ pedidosConCheck: [] });


    });

  }

  loadPage(tipo) {
    this.setState({pedidosConCheck: []});
    document.addEventListener('click', toggleDiv, true);
    const { id } = this.props.match.params;
    let ArrayListPerfil = [];

    this.setState({numFichaVtaVeh:id});
    this.props.fetchPermisos(id);
    /*Inicio Req 92528 ebarboza 30 08 2021 */
    this.props.fetchFichaVentaCorreos(id).then(resulCorreos =>{
      if(resulCorreos.payload.data.estadoTrama === "1"){
        this.setState({listaCorreos:resulCorreos.payload.data.listaCorreos})
      }
    });
    /*Fin Req 92528 ebarboza 30 08 2021 */

    this.props.fetchSeguimientoAutorizaciones().then(result => {
      this.setState({seguimientoAutorizaciones:result.payload.data.listado})
    })

    this.fnListadoPedidosFacturacion(id);
    this.onClickListUsuarioAprobadores(id);
    this.loadProformas(id);
    this.loading('block');
    this.fnSolicitudFacturacion(id);
    this.props.fetchEstados();
    this.props.fetchTipoAutorizacion();
    this.fnFetchEquiposCortesia(id);
    this.props.fetchGestionCosto(id, 'L');
    this.props.fetchResponsables();
    this.props.fetchAutorizacionesExcepcionales(id);
    this.props.fetchProveedorEquposAdicionales('', '', '1');

    if (tipo === 1) {
      const mensaje = 'La Transaccion se ejecuto Correctamente';
      this.setState({ alertSuccessMessage: mensaje });
      this.showAlert('alertSuccessOpen');
    }

    this.loading('');

  }

  fnFetchEquiposCortesia = (id) => {
    this.loading('block');
    this.props.fetchEquiposCortesia(id).then((result) => {
      if(result.payload.data.listadoAdicionales.length===0){
        this.setState({ equiposCortesia: {estadoTrama:'1',listadoAdicionales:[{desEquipoLocalVeh:'sdsdsd',skuSap:'12',valPrecioVtaTotal:'sdfdf'}]} });

      }else{
        this.setState({ equiposCortesia: result.payload.data });
      }

    }).catch((error) => {
      console.log(error);
    });;
  }

  fnFetchEquiposCortesia = (id) => {
    this.loading('block');
    this.props.fetchEquiposCortesia(id).then((result) => {
      if(result.payload.data.listadoAdicionales.length===0){
        this.setState({ equiposCortesia: {estadoTrama:'1',listadoAdicionales:[{desEquipoLocalVeh:'sdsdsd',skuSap:'12',valPrecioVtaTotal:'sdfdf'}]} });

      }else{
        this.setState({ equiposCortesia: result.payload.data });
      }

    }).catch((error) => {
      console.log(error);
    });
  }

  togglePanelEstadoGestionCosto = (items) => {
    console.log(items);
    if (items === this.state.estadoGestionCosto) {
      this.setState({ estadoGestionCosto: '' });
    } else {
      this.setState({ estadoGestionCosto: items });
    }
  }

  addPedidosAsignarBonos = (items) => {
    console.log('select check preasignados'+items);
    if(this.state.arrayAsignarBonos.indexOf(items)>=0){
      this.setState({
        arrayAsignarBonos: this.state.arrayAsignarBonos.filter(x => x !== items),
      });
    }else{
      this.setState({arrayAsignarBonos: [...this.state.arrayAsignarBonos,items]});
    }
  }

  openEquipoAdicionales = (modal, proforma) => {

    let pedido =  _.filter(this.state.pedidosXfichaVenta, _.property(proforma.numProfVeh))[0][proforma.numProfVeh];
    let statusPedido = pedido.filter(entry => this.state.facturacionListado.map(facturacionPedido => {return facturacionPedido.numPedidoVeh}).indexOf(entry.numPedidoVeh)>=0)
                             .filter(pedido => pedido.estadoPedido===ESTADO_PEDIDO_ASIGNADO);

    if(statusPedido.length>0){
      this.setState({ numProformaEquiposAdicionales: proforma.numProfVeh,proformaSeleccionadaTabEquipoLogistica:proforma,tipoLlamadaEquiposAdicionales:'1' });
      this.setState({ pedidosEquiposAdicionales: statusPedido });
      this.openModal(modal);
    }else{
      this.openAlert({
        estadoTrama: '1',
        mensaje: 'No se puede agregar equipos logistica, valide que los pedidos tengan estado Asignado.'
      })
    }

  }

  eliminarEquiposAdicionales = (numPedidoVeh) => {
    this.setState({ pedidosEquiposAdicionales: this.state.pedidosEquiposAdicionales.filter(entry => entry.numPedidoVeh!==numPedidoVeh)})
  }

  handleChange(e) {
    this.setState({ searchOption: e.target.value, clientInput: '' });
  }


  search = (option, value) => {
    this.setState({ valueSerach: value });
    this.setState({ optionSearch: option });
    this.setState({ muestraLoad: 'block' });
    this.props.fetchClientes(option, value).then((result) => {
      this.setState({ muestraLoad: '' });
    }).catch((error) => {
      console.log(error);
    });
    return true;
  }

  searchClientesPedidos = (option, value) => {
    this.setState({ valueSerach: value });
    this.setState({ optionSearch: option });
    this.setState({ muestraLoad: 'block' });
    this.props.fetchClientesPedidos(option, value).then((result) => {
      this.setState({ muestraLoad: '' });
    }).catch((error) => {
      console.log(error);
    });
    return true;
  }

  searchProveedorEquiposAdicionales = (option, value) => {
    this.setState({ valueSerach: value });
    this.setState({ optionSearch: option });
    this.setState({ muestraLoad: 'block' });

    this.props.fetchProveedorEquposAdicionales('', value, '1').then((result) => {
      this.setState({ muestraLoad: '' });
    }).catch((error) => {
      console.log(error);
    });

    return true;
  }


  goToClients() {
    this.setState({ clientsTable: true, proformasTable: false, clientName: '', companyFilter: '', areaVentaFilter: '', selected: [], vendedorId: '', vendedorName: '' });
  }

  renderFunHideClienFact(id, opcionPedidoUsuario) {
    if (document.getElementById(id).className === 'collapse in') {
      document.getElementById(id).className = 'collapse';
    } else {
      document.getElementById(id).className = 'collapse in';
    }
    document.getElementById(opcionPedidoUsuario).className = 'collapse';
  }


  deleteDuplicate(arr, prop) {
    const nuevoArray = [];
    const lookup = {};

    for (var i in arr) {
      lookup[arr[i][prop]] = arr[i];
    }

    for (i in lookup) {
      lookup[i].checked1 = false;
      lookup[i].checked2 = true;
      nuevoArray.push(lookup[i]);
    }

    return nuevoArray;
  }

  componentWillUnmount() {
    document.removeEventListener('click', toggleDiv, true);
  }

  onChangeInput = e => this.setState({ [e.target.name]: e.target.value });

  selectTab = index => {
    this.setState({ tabSeleccionado: index });
  }

  selectProforma = (proforma) => {
    if (this.state.proformaSeleccionada === proforma) {
      this.setState({ proformaSeleccionada: '' });
    } else {
      this.setState({ proformaSeleccionada: proforma });
    }
  }


  validateUser = () => {
    this.loading('block');
    const { id } = this.props.match.params;
    const autorizador = this.state.autorizaciones.filter(autorizacion => autorizacion.codAprobFichaVtaAut !== 'A')[0];
    console.log('autorizador.desAutFichaVta',autorizador);
    this.props.validarUsuarioAutorizador(id, autorizador.codAutFichaVta,'','','',autorizador.desAutFichaVta)
      .then((response) => {
        if (response.payload.data.estadoTrama === '0') {
          this.setState({ alertErrorMessage: response.payload.data.mensaje });
          this.showAlert('alertErrorOpen');
          this.loading('');
        } else {
          autorizarActividad(id, autorizador.codAutFichaVta)
            .then((r) => {
              this.openAlert(r.data);
              this.props.fetchFichaVenta(id);
              this.props.fetchAutorizaciones(id).then((result) => {
                    this.setState({ autorizaciones: result.payload.data.actividadesList });
                    this.loading('');
                  })
                  .catch((error) => {console.log(error)});;;
            });

        }
      });
  }

  closeModal = () => {

    this.setState({ modalOpen: ''})
  }

  openModal = (modal) => {
    this.setState({ modalOpen: modal });
  }

  closeAlertError = () => this.setState({ alertErrorOpen: false, proveedorEquposAdicionalesModalOpen:false });
  closeAlertSuccess = () => this.setState({ alertSuccessOpen: false });
  closeAlertErrorModFacturacion = () => this.setState({ alertErrorOpenModFacturacion: false });

  closeModalFacturacion = () => {
    this.setState({ modalOpen: '' });
    this.loadPage();
  }

  handlePageClickEquiposEspeciales = ({ selected }) => {
    this.props.fetchProveedorEquposAdicionales('', this.state.valueSerach, selected + 1);
  }

  showDetallePedido = (idPedido) => {
    console.log(`idPedido:${idPedido}`);
    this.openModal('PedidoDetalle');
  }

  showAlert = (alertType) => {
    this.setState({ [alertType]: true });
    setTimeout(() => this.setState({ [alertType]: false }), 5000);
  }

  openAlert = (data) => {
    if (data.estadoTrama === '0') {
      this.setState({ alertErrorMessage: data.mensaje });
      this.showAlert('alertErrorOpen');
    } else if (data.estadoTrama === '1') {
      this.setState({ alertSuccessMessage: data.mensaje });
      this.showAlert('alertSuccessOpen');
    } else {
      this.setState({ alertErrorMessage: `Hubo un error con el servicio ${data.estadoTrama}` });
      this.showAlert('alertErrorOpen');
    }
  }

  openAlertFacturacion = (data) => {
    if (data.estadoTrama === '0') {
      this.setState({ alertErrorMessage: data.mensaje });
      this.showAlert('alertErrorOpenModFacturacion');
    } else if (data.estadoTrama === '1') {
      this.setState({ alertSuccessMessage: data.mensaje });
      this.showAlert('alertErrorOpenModFacturacion');
    } else {
      this.setState({ alertErrorMessage: `Hubo un error con el servicio ${data.estadoTrama}` });
      this.showAlert('alertErrorOpenModFacturacion');
    }
  }
 loading = (status) =>{
    this.setState({ muestraLoad: status });
  }

  showRow = (index) => {
    console.log(index);
    const { pedidoAcordeon } = this.state;
    if (pedidoAcordeon === index) {
      this.setState({ pedidoAcordeon: '' });
    } else {
      this.setState({ pedidoAcordeon: index });
    }
  }

  searchFDV = () => {
      this.props.loadFichasVenta();
      this.props.clearProformas();
      const { searchInput, typeSearch } = this.state;
      this.props.fetchFichasVenta('', '1', '1', typeSearch, searchInput)
        .then(() => {
          const fichasVenta = this.props.fichasVenta.fichaVentaResponse;
            const fdvID =fichasVenta[0] === undefined?undefined:fichasVenta[0].numFichaVtaVeh;
            this.props.history.push(`/fichas-venta/${fdvID}`);
            window.location.reload();

        });
    }

  fnSeleccionAutorizador=(codAutFichaVta)=>{
    this.setState({autorizadoSeleccionado:this.state.listUsuarioAprobadores[codAutFichaVta]})

  }

  onClickListUsuarioAprobadores = (id) =>{
    let usuariosAutorizadores = [];
    let autorizaciones = [];

    this.props.fetchAutorizaciones(id)
    .then((result) => {
      autorizaciones = result.payload.data.actividadesList;
      autorizaciones.forEach(entry => {
        this.props.fetchAutorizacionesUsuarios(entry.numFichaVtaVeh,entry.codCia,entry.codProv,entry.numPedidoVeh,entry.codAutFichaVta)
        .then((result) => {
          usuariosAutorizadores=this.state.listUsuarioAprobadores;
          console.log('result.payload.data.usuarioAutorizadorList',result.payload.data.usuarioAutorizadorList);
          usuariosAutorizadores[entry.codAutFichaVta]=result.payload.data.usuarioAutorizadorList;
          this.setState({listUsuarioAprobadores:usuariosAutorizadores});
        })
      })

      this.setState({autorizaciones:autorizaciones});


    })
    .catch((error) =>
      console.log(error)
    );



  }

  removeDuplicates(originalArray, prop) {
     var newArray = [];
     var lookupObject  = {};

     for(var i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
     }

     for(i in lookupObject) {
         newArray.push(lookupObject[i]);
     }
      return newArray;
 }


 loadProformas = (id) => {

  this.setState({pedidosConCheck: [],pedidosXfichaVenta:[]});

  this.props.fetchProformas(id).then((result) => {

    const idsProformas = result.payload.data.proformaExistenteList.map(row => row.numProfVeh);
    this.setState({ idsProformas });
    if (this.state.activeFilterPedido === 0) {
      getPedidosPedidos(id, idsProformas).then((result2) => {
        console.log('result2',result2);

        this.setState({ pedidosXfichaVenta: result2 });
      });
    }
  }).catch((error) => {
    console.log(error);
  });
}


descargaFichaVenta = () =>{

  this.loading('block');
  const { id } = this.props.match.params;
  this.props.fetchProformas(id).then((result) => {

    if (this.props.proformas.proformaExistenteList.length) {
      this.props.fetchReporteFichaVenta(this.props.proformas.proformaExistenteList[0].numProfVeh).then(entry => {
        this.descargarPDF(entry.payload.data.reportePdf);
        this.loading('');
      });
    } else {
      this.props.fetchReporteFichaVenta().then(entry => {
        this.descargarPDF(entry.payload.data.reportePdf);
        this.loading('');
      });
    }
    const idsProformas = result.payload.data.proformaExistenteList.map(row => row.numProfVeh);
    this.setState({ idsProformas });
    if (this.state.activeFilterPedido === 0) {
      getPedidosFechas(id, idsProformas).then((result2) => {
        this.setState({ pedidosXfichaVenta: result2 });
      });
    }
  }).catch((error) => {
    console.log(error);
  });

}

descargarPDF = (reportePdf) => {
  const contentType = 'application/vnd.ms-pdf';
  const b64Data = reportePdf;
  const fileName = 'ficha-de-ventas.pdf';
  saveAs(b64Data, contentType, fileName);
}

  render() {
    const { facturacion } = this.props;
    const { id } = this.props.match.params;
    const {
      fichasVenta, autorizaciones, proformas,
      autorizacionesExcepcionales,
    } = this.props;

    if (id === 'undefined') {
      return (

        <div>
          <PageHeader title='Fichas de venta' openModal={this.openModal} buttonName='Nueva ficha de venta' modalName='nueva-fdv' handlePermissions={this.handlePermissions} />
              <BuscarFicha
                searchFDV={this.searchFDV}
                typeSearch={this.state.typeSearch}
                selectName='typeSearch'
                inputName='searchInput'
                inputValue={this.state.searchInput}
                onChangeInput={this.onChangeInput}
              />

            <Alert type='alert-warning' icon='ion-alert-circled'>
              <p>La ficha de venta o proforma buscada no se encuentra en el sistema.</p>
            </Alert>
        </div>
      );
    }

    if (
      !fichasVenta || !autorizaciones ||
      !proformas || !proformas.proformaExistenteList ||
      !autorizacionesExcepcionales || !autorizacionesExcepcionales.listadoSolicitudes
    ) {
      return (
        <div className='modal fdv in' id='fdv-detalle' role='dialog' data-backdrop='static' style={{ display: 'block' }}>
          <div className='modal-dialog modal-lg modal-noTitle' role='document'>
            <FadeLoader color={'#F8A14A'} loading />
          </div>
        </div>
      );
    }

    {console.log('fichasVenta.fichaVentaResponse',fichasVenta.fichaVentaResponse)}
    //{console.log('fichasVenta.fichaVentaResponse',fichasVenta.fichaVentaResponse.length)}
    if (!fichasVenta.fichaVentaResponse) {
    return (

        <div>
          <PageHeader title='Fichas de venta' openModal={this.openModal} buttonName='Nueva ficha de venta' modalName='nueva-fdv' handlePermissions={this.handlePermissions} />;
          {
            this.state.modalOpen === 'nueva-fdv' &&
              <NuevaFichaVenta
                querys={qs.parse(this.props.location.search)}
                closeModal={this.closeModal}
              />
          }
          <Alert type='alert-warning' icon='ion-alert-circled'>
            <p>No tiene acceso a la siguiente ficha de venta.</p>
          </Alert>
        </div>
      );
    }

    return (
      <div>
        <PageHeader title='Fichas de venta' openModal={this.openModal} buttonName='Nueva ficha de venta' modalName='nueva-fdv' handlePermissions={this.handlePermissions} />
        {
          fichasVenta.fichaVentaResponse[0].codEstadoFichaVtaVeh === 'C' &&
            <Alert type={'alert-info alert-top alert-autorizacion'} icon='ion-information-circled'>
              <p>¡Esta ficha necesita tu autorización para ser publicada!</p>
              <button className='btn btn-info' onClick={this.validateUser}  data-permisos='ind_alert-autorizacion'>
                Validar
              </button>
            </Alert>
        }
        <BuscarFicha
          searchFDV={this.searchFDV}
          typeSearch={this.state.typeSearch}
          selectName='typeSearch'
          inputName='searchInput'
          inputValue={this.state.searchInput}
          onChangeInput={this.onChangeInput}
        />
        <Detalle
          fdv={fichasVenta.fichaVentaResponse[0]}
          autorizaciones={_.uniqBy(this.state.autorizaciones, 'codAutFichaVta')}
          openModal={this.openModal}
          descargaFichaVenta = {this.descargaFichaVenta}
          onClickListUsuarioAprobadores={this.onClickListUsuarioAprobadores}
          listUsuarioAprobadores={this.state.listUsuarioAprobadores}
          fnSeleccionAutorizador={this.fnSeleccionAutorizador}
          autorizadoSeleccionado={this.state.autorizadoSeleccionado}
          handlePermissions={this.handlePermissions}
        />
        <Tabs selectTab={this.selectTab} tabSeleccionado={this.state.tabSeleccionado} />

        <div className='fdv-contentWrapper'>
          <div className='tab-content wrapper'>
            { renderTabcontainer(id, this) }
          </div>
        </div>

        <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ display: this.state.muestraLoad }} >
          <div className='modal-dialog modal-sm' role='document'>
            <FadeLoader color={'#F8A14A'} loading />
          </div>
        </div>

        <PedidoDetalle
          isOpen={this.state.modalOpen === 'PedidoDetalle'}
          closeModal={this.closeModal}
        />

        { showModal(this.state.modalOpen, this) }

        { this.state.alertErrorOpen &&
          <Alert type='alert-warning' icon='ion-alert-circled' closeAlert={this.closeAlertError}>
            <p>{this.state.alertErrorMessage}</p>
          </Alert>
        }
        { this.state.alertSuccessOpen &&
          <Alert type='alert-success' icon='ion-checkmark-circled' >
            <p>{this.state.alertSuccessMessage}</p>
          </Alert>
        }

        {
          facturacion && facturacion.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar Facturacion</p>
            </Alert> : null
        }

        {
          this.props.proveedorEquposAdicionales && this.props.proveedorEquposAdicionales.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar proveedores de equipos adicionales</p>
            </Alert> : null
        }

        {
          this.state.proveedorEquposAdicionalesModalOpen && this.props.equiposLogistica && this.props.equiposLogistica.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled' closeAlert={this.closeAlertError}>
              <p>{this.props.equiposLogistica.mensaje}</p>
            </Alert> : null
        }

        {
          this.props.fichasVenta && this.props.fichasVenta.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar fichasVenta</p>
            </Alert> : null
        }

        {
          this.props.autorizaciones && this.props.autorizaciones.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar autorizaciones</p>
            </Alert> : null
        }

        {
          this.props.proformas && this.props.proformas.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar proformas</p>
            </Alert> : null
        }

        {
          this.props.historial && this.props.historial.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar historial</p>
            </Alert> : null
        }

        {
          this.props.estados && this.props.estados.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar estados</p>
            </Alert> : null
        }

        {
          this.props.tipoAutorizacion && this.props.tipoAutorizacion.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar tipoAutorizacion</p>
            </Alert> : null
        }

        {
          this.props.responsables && this.props.responsables.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar responsables</p>
            </Alert> : null
        }

        {
          this.props.facturacion && this.props.facturacion.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar facturacion</p>
            </Alert> : null
        }

        {
          this.props.clientes && this.props.clientes.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar clientes</p>
            </Alert> : null
        }

        {
          this.props.pedidos && this.props.pedidos.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar clientes</p>
            </Alert> : null
        }

        {
          this.props.autorizacionesExcepcionales && this.props.autorizacionesExcepcionales.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar autorizacionesExcepcionales</p>
            </Alert> : null
        }

        {
          this.props.equiposLogistica && this.props.equiposLogistica.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar equiposLogistica</p>
            </Alert> : null
        }

        {
          this.props.proveedorEquposAdicionales && this.props.proveedorEquposAdicionales.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar proveedorEquposAdicionales</p>
            </Alert> : null
        }

        {
          this.props.reporte && this.props.reporte.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar reporte</p>
            </Alert> : null
        }
        {
          this.props.equiposCortesia && this.props.equiposCortesia.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar equiposCortesia</p>
            </Alert> : null
        }

        {
          this.props.gestionCosto && this.props.gestionCosto.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar gestionCosto</p>
            </Alert> : null
        }

        {
          this.props.permisos && this.props.permisos.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar permisos</p>
            </Alert> : null
        }

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    fichasVenta: state.fichasVenta,
    autorizaciones: state.autorizaciones,
    proformas: state.proformas,
    historial: state.historial,
    estados: state.estados,
    excepcionales: state.tipoAutorizacion,
    responsables: state.responsables,
    facturacion: state.facturacion,
    clientes: state.clientes,
    pedidos: state.pedidos,
    autorizacionesExcepcionales: state.autorizacionesExcepcionales,
    equiposLogistica: state.equiposLogistica,
    proveedorEquposAdicionales: state.proveedorEquposAdicionales,
    reporte: state.reporte,
    equiposCortesia: state.equiposCortesia,
    gestionCosto: state.gestionCosto,
    permisos: state.permisos
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchFichasVenta,
    fetchFichaVenta,
    fetchFichaVentaCorreos,//Req 92528 ebarboza 28 08 2021
    fetchAutorizaciones,
    fetchProformas,
    fetchHistorialFDV,
    loadFichasVenta,
    clearProformas,
    fetchEstados,
    fetchTipoAutorizacion,
    fetchResponsables,
    fetchAutorizacionesExcepcionales,
    fetchFacturacion,
    fetchClientes,
    fetchClientesPedidos,
    fetchPedidos,
    fetchEditarFacturacion,
    fetchEquiposLogisticaDetalle,
    fetchEquiposAdicionales,
    fetchProveedorEquposAdicionales,
    fetchReporteFichaVenta,
    fetchReporteConsultaFichaVenta,
    fetchEquiposCortesia,
    fetchGestionCosto,
    fetchAutorizacionesUsuarios,
    fetchSolicitudesFacturacion,
    saveAutorizacionesExcepcionales,
    fetchSeguimientoAutorizaciones,
    validarUsuarioAutorizador,
    fetchPermisos,
    fetchTipoActividad
  })(DetalleFichaVenta)
);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetalleFichaVenta.js